"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import type { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import UserPageRepNewRepSearch from "./UserPageRepNewRepSearch";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { AnimatePresence } from "framer-motion";
export default function UserPageRepNewRep(t0) {
  const $ = _c(16);
  const {
    profile,
    repRates
  } = t0;
  const [isAddNewRepModalOpen, setIsAddNewRepModalOpen] = useState(false);
  const [repToAdd, setRepToAdd] = useState(null);
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    t1 = repSearch => {
      const rep = repRates?.rating_stats.find(r => r.category === repSearch) ?? {
        category: repSearch,
        rating: 0,
        contributor_count: 0,
        rater_contribution: 0
      };
      setRepToAdd(rep);
      setIsAddNewRepModalOpen(true);
    };
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onRepSearch = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsAddNewRepModalOpen(false);
      setRepToAdd(null);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onCloseModal = t2;
  let t3;
  if ($[3] !== onRepSearch || $[4] !== profile || $[5] !== repRates) {
    t3 = <UserPageRepNewRepSearch onRepSearch={onRepSearch} repRates={repRates} profile={profile} />;
    $[3] = onRepSearch;
    $[4] = profile;
    $[5] = repRates;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isAddNewRepModalOpen || $[8] !== profile || $[9] !== repToAdd) {
    t4 = isAddNewRepModalOpen && repToAdd && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageRepModifyModal profile={profile} category={repToAdd.category} onClose={onCloseModal} /></CommonAnimationOpacity>;
    $[7] = isAddNewRepModalOpen;
    $[8] = profile;
    $[9] = repToAdd;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <AnimatePresence mode="sync" initial={true}>{t4}</AnimatePresence>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}